import * as t from "io-ts";

export const ClientId = t.string;

export type ClientId = t.TypeOf<typeof ClientId>;

export const ClientName = t.string;

export type ClientName = t.TypeOf<typeof ClientName>;

export const OnlyUsersFromMyOPU = t.boolean;

export type OnlyUsersFromMyOPU = t.TypeOf<typeof ClientName>;

export type Filters = {
  clientId: string;
  clientName: string;
  onlyUsersFromMyOPU: boolean;
};
